import { Link } from 'react-router-dom';
import NewsletterForm from '../common/NewsletterForm';

export default function Footer() {
    return (
        <footer className="mt-24 border-t border-neutral-200 bg-[#F7F7F5]">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
                <div className="lg:col-span-4">
                    <div className="flex items-center gap-2 mb-4">
                        <span className="inline-block w-2 h-2 rounded-full" style={{ background: '#C8A24A' }} />
                        <span className="font-editorial text-[19px] tracking-tight">
                            BestNeighbourhoods<span className="text-neutral-400">.ca</span>
                        </span>
                    </div>
                    <p className="font-editorial text-[22px] leading-[1.35] max-w-md tracking-editorial">
                        Southern Ontario's neighbourhood intelligence platform. Trusted data. Local knowledge. Financial insight.
                    </p>
                    <p className="mt-4 text-sm text-neutral-500 max-w-md">
                        We do not sell homes. We reduce the uncertainty around the largest financial decision a family will ever make.
                    </p>
                    {/* apostrophes preserved without escapes are safe within JSX text nodes on this line */}
                </div>

                <div className="lg:col-span-3">
                    <div className="overline mb-4">Focus markets</div>
                    <ul className="space-y-2 text-[14px] text-neutral-700">
                        <li><Link to="/durham" className="link-editorial hover:text-brand-navy">Durham Region</Link></li>
                        <li><Link to="/hamilton" className="link-editorial hover:text-brand-navy">Hamilton</Link></li>
                        <li><Link to="/burlington" className="link-editorial hover:text-brand-navy">Burlington</Link></li>
                        <li><Link to="/oakville" className="link-editorial hover:text-brand-navy">Oakville</Link></li>
                        <li><Link to="/milton" className="link-editorial hover:text-brand-navy">Milton</Link></li>
                        <li><Link to="/halton-hills" className="link-editorial hover:text-brand-navy">Halton Hills</Link></li>
                        <li><Link to="/brantford" className="link-editorial hover:text-brand-navy">Brantford</Link></li>
                        <li><Link to="/brant-county" className="link-editorial hover:text-brand-navy">Brant County</Link></li>
                        <li><Link to="/niagara" className="link-editorial hover:text-brand-navy">Niagara Region</Link></li>
                    </ul>
                </div>

                <div className="lg:col-span-2">
                    <div className="overline mb-4">Explore</div>
                    <ul className="space-y-2 text-[14px] text-neutral-700">
                        <li><Link to="/match" className="link-editorial hover:text-brand-navy">The Match Assessment</Link></li>
                        <li><Link to="/neighbourhoods" className="link-editorial hover:text-brand-navy">All neighbourhoods</Link></li>
                        <li><Link to="/buyer-centre" className="link-editorial hover:text-brand-navy">Buyer Centre</Link></li>
                        <li><Link to="/seller-centre" className="link-editorial hover:text-brand-navy">Seller Centre</Link></li>
                        <li><Link to="/investor-centre" className="link-editorial hover:text-brand-navy">Investor Centre</Link></li>
                        <li><Link to="/videos" className="link-editorial hover:text-brand-navy">Video Centre</Link></li>
                        <li><Link to="/affordability" className="link-editorial hover:text-brand-navy">Affordability</Link></li>
                        <li><Link to="/compare" className="link-editorial hover:text-brand-navy">Compare</Link></li>
                        <li><Link to="/insights" className="link-editorial hover:text-brand-navy">Insights</Link></li>
                    </ul>
                </div>

                <div className="lg:col-span-3">
                    <div className="overline mb-4">Get the weekly briefing</div>
                    <p className="text-sm text-neutral-600 mb-4">
                        Data, analysis, and one neighbourhood worth watching. No listings. No spam.
                    </p>
                    <NewsletterForm source="footer" />
                </div>
            </div>
            <div className="border-t border-neutral-200">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-neutral-500">
                    <div>&copy; {new Date().getFullYear()} BestNeighbourhoods.ca. Independent neighbourhood research for Southern Ontario. Not a brokerage.</div>
                    <div className="flex items-center gap-4">
                        <Link to="/privacy" className="hover:text-brand-navy underline underline-offset-2" data-testid="footer-privacy-link">Privacy</Link>
                        <Link to="/terms" className="hover:text-brand-navy underline underline-offset-2" data-testid="footer-terms-link">Terms</Link>
                    </div>
                    <div className="flex gap-6 flex-wrap">
                        <span>Durham</span><span>Hamilton</span><span>Burlington</span><span>Oakville</span><span>Milton</span><span>Halton Hills</span><span>Brant</span><span>Niagara</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
